module.exports = __webpack_public_path__ + "img/IconAlertProject.0a41fb00.png";